<template>
  <div class="station-member" style="padding: 0 30px;">
    <div class="pl pr pt pb bg-title text-primary">已绑定{{members.length}}位用户</div>
    <el-scrollbar v-loading="loading" :native="false" style="height: calc(100vh - 390px)">
      <ul class="member-box">
        <li v-for="mem in members" :key="'member'+ mem.uid" class="member-item flex mb-sm">
          <div class="hd flex-center">
            <f-user-avatar :user="mem"></f-user-avatar>
          </div>
          <div class="bd flex pl">
            <div class="hd flex column justify-content-space-between pt-sm pb-sm">
              <span>{{mem.username}}</span>
              <span class="text-muted">{{mem.bindtime | parseTime('{y}-{m}-{d}')}}</span>
            </div>
            <div class="bd flex-center column">
              <span>
                <img
                  v-if="mem.role == 'operator'"
                  src="@/assets/operator-icon.png"
                  class="avatar rounded"
                />
                <img
                  v-if="mem.role == 'inspector'"
                  src="@/assets/inspector-icon.png"
                  class="avatar rounded"
                />
              </span>
              <span class="text-muted">{{roles[mem.role]}}</span>
            </div>
          </div>
          <div class="ft flex-center">
            <el-button type="text" @click="deleteOne(mem)">删除</el-button>
          </div>
        </li>
      </ul>

      <div v-if="!members.length" class="flex-center column mt-hg">
        <img class="image huger mt-mg" src="@/assets/empty.png" />
        <div class="font-md mb-hg">暂无数据</div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { getStationUserApi, unbindApi } from "@/api/pp/stationApi";
export default {
  props: {
    stationid: {
      type: [Number, String],
    },
  },
  data() {
    return {
      members: [],
      roles: {
        operator: "操作者",
        inspector: "质检员",
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    deleteOne(item) {
      this.$confirm(
        `确定从工位<span class="text-primary">【${"GW00003"}】</span>上删除<span class="text-primary">【${
          item.username
        }】</span>么？`,
        "提示",
        {
          type: "warning",
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      ).then(() => {
        const temp = {
          stationid: this.stationid,
          uid: item.uid,
          role: item.role,
        };
        unbindApi(temp).then((res) => {
          this.loading = false;
          if (!res.errno) {
            this.$message.success("解绑成功！");
            this.fetchData();
            this.$emit("change");
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    fetchData() {
      this.loading = true;
      getStationUserApi({ stationid: this.stationid }).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.members = res.data.list;
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.station-member {
  width: 100%;

  .bg-title {
    background-color: #eef8e8;
  }

  .member-box {
    padding: 20px 2px;

    .member-item {
      box-shadow: 0px 1px 6px 1px rgba(0, 0, 0, 0.1);
      padding: 10px 15px;
      border-radius: 5px;
    }
  }
}
</style>